import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./agendamento-despesa-listar/agendamento-despesa-listar.module').then(m => m.AgendamentoDespesaListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./agendamento-despesa-inserir/agendamento-despesa-inserir.module').then(m => m.AgendamentoDespesaInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./agendamento-despesa-editar/agendamento-despesa-editar.module').then(m => m.AgendamentoDespesaEditarModule) }

    ])],
    exports: [RouterModule]
})
export class AgendamentoDespesaAppRoutingModule { }